if (!customElements.get('category-picker')) {
  customElements.define('category-picker', class CategoryPicker extends HTMLElement {
    constructor() {
      super()
      
      // bindings
      this.selectSection = this.selectSection.bind(this)

      // elements
      this.underline = this.querySelector('hr')
      this.buttons = this.querySelectorAll('button')

      // events
      this.buttons.forEach((btn, i) => {
        btn.addEventListener('click', () => this.selectSection(i))
      })

      this.selectSection(0)
    }

    selectSection(number) {
      this.underline.style.width = `${this.buttons[number].clientWidth}px`
      this.underline.style.marginLeft = number === 0 ? 0 : `${this.buttons[number].offsetLeft}px`
      this.buttons.forEach((btn, i) => {
        btn.setAttribute('aria-current', i === number ? 'true' : 'false')
      })
      document.dispatchEvent(new CustomEvent('category-picker-change',{ detail: { number }}));
    }
  })
}